import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './WorldsList.css';

function WorldsList() {
  const [worlds, setWorlds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [newWorld, setNewWorld] = useState({ name: '', description: '' });
  const [showForm, setShowForm] = useState(false);
  
  useEffect(() => {
    fetchWorlds();
  }, []);
  
  const fetchWorlds = async () => {
    try {
      const response = await fetch('/api/worlds');
      if (!response.ok) {
        throw new Error('Failed to fetch worlds');
      }
      
      const data = await response.json();
      setWorlds(data);
    } catch (error) {
      setError('Error loading worlds. Please try again.');
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        response: error.response // If using axios
      });
    } finally {
      setLoading(false);
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewWorld(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newWorld.name.trim()) {
      return;
    }
    
    try {
      const response = await fetch('/api/worlds', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newWorld),
      });
      
      if (!response.ok) {
        throw new Error('Failed to create world');
      }
      
      const createdWorld = await response.json();
      setWorlds(prev => [...prev, createdWorld]);
      setNewWorld({ name: '', description: '' });
      setShowForm(false);
    } catch (error) {
      console.error('Error creating world:', error);
    }
  };
  
  if (loading) {
    return <div className="loading">Loading worlds...</div>;
  }
  
  return (
    <div className="worlds-container">
      <h2>Available Worlds</h2>
      {error && <div className="error-message">{error}</div>}
      
      <div className="worlds-grid">
        {worlds.map(world => (
          <div key={world.id} className="world-card">
            <h3>{world.name}</h3>
            <p>{world.description || 'No description available'}</p>
            <Link to={`/worlds/${world.id}`} className="enter-button">
              Enter World
            </Link>
          </div>
        ))}
      </div>
      
      {!showForm ? (
        <button className="create-button" onClick={() => setShowForm(true)}>
          Create New World
        </button>
      ) : (
        <form className="world-form" onSubmit={handleSubmit}>
          <h3>Create New World</h3>
          <div className="form-group">
            <label htmlFor="name">World Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={newWorld.name}
              onChange={handleInputChange}
              placeholder="Enter world name"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={newWorld.description}
              onChange={handleInputChange}
              placeholder="Enter world description"
              rows="3"
            />
          </div>
          <div className="form-actions">
            <button type="submit">Create</button>
            <button type="button" onClick={() => setShowForm(false)}>Cancel</button>
          </div>
        </form>
      )}
    </div>
  );
}

export default WorldsList; 